import React from 'react';

const ArrowUpLineIcon = ({ style }: { style?: React.CSSProperties }) => {
    return (
        <svg
            style={style}
            viewBox="0 0 24 24"
            fill="currentColor"
            width="1em"
            height="1em"
        >
            <path d="M12 8.99951L16.2426 13.242L14.8284 14.6562L12 11.8278L9.17154 14.6562L7.75732 13.242L12 8.99951Z" />
        </svg>
    );
};

export default ArrowUpLineIcon;
